import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAppointment } from '../../../models/appointment.interface';
import { ActionClick, RowClick } from '../../../models/data-table.interface';
import { environment } from '../../../../environments/environment';

@Component({
    standalone: false,
    selector: 'cva-appointment-card',
    templateUrl: './appointment-card.component.html',
    styleUrl: './appointment-card.component.scss',
    
})
export class AppointmentCardComponent {
  @Input() appointment!: IAppointment;
  @Input() isRowClickable: boolean = true;
  @Output() rowClick: EventEmitter<RowClick<IAppointment>> = new EventEmitter<RowClick<IAppointment>>();
  @Output() actionClick: EventEmitter<ActionClick<IAppointment>> = new EventEmitter<ActionClick<IAppointment>>();
  cvaUI_url: string = environment.cvaUI_url;

  constructor() { }

  onRowClicked(): void {
    if (!this.isRowClickable || this.appointment.isDeleted) {
      return;
    }
    this.rowClick.emit({ rowData: this.appointment });
  }

  onAction(event: MouseEvent, action: 'edit' | 'delete' | 'transcription') {
    event.stopPropagation();
    this.actionClick.emit({ rowData: this.appointment, action });
  }

  //This function is just to avoid SONAR warning
  doNothing() {
    console.log("Do nothing");
  }
}
